import React, { FC } from 'react';
import { Link } from '@digdir/designsystemet-react';

import Logo from '../../../../../assets/images/logo.svg?react';

import styles from './balderHeader.module.css';

interface Props {
  title?: string;
  children: React.ReactNode;
  logoWrapper?: React.ComponentType<LogoWrapperProps>;
}

export type LogoWrapperProps = {
  children: React.ReactNode;
  className?: string;
};

interface SlotProps {
  children: React.ReactNode;
}

function RightContent({ children }: SlotProps) {
  return <div className={styles.rightContent}>{children}</div>;
}

function LeftContent({ children }: SlotProps) {
  return <div className={styles.leftContent}>{children}</div>;
}

type HeaderSubComponents = FC<Props> & {
  RightContent: typeof RightContent;
  LeftContent: typeof LeftContent;
};

const DefaultLogoWrapper: FC<LogoWrapperProps> = ({ children, className }) => (
  <Link href="/" className={className}>
    {children}
  </Link>
);

// TODO: Move component to @enovasf/balder-react
const BalderHeader: FC<Props> & HeaderSubComponents = ({ children, title, logoWrapper: LogoWrapper }) => {
  const LogoContainer = LogoWrapper ?? DefaultLogoWrapper;

  return (
    <header className={styles.header}>
      <div className={styles.headerContentWrapper}>
        <LogoContainer className={styles.logoLink}>
          <Logo aria-label="Enova" />
          {title && <span className={styles.titleWrapper}>| {title}</span>}
        </LogoContainer>
        <div className={styles.content}>{children}</div>
      </div>
    </header>
  );
};

BalderHeader.RightContent = RightContent;
BalderHeader.LeftContent = LeftContent;

export default BalderHeader;
